import React from "react";
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import TranslateIcon from "@mui/icons-material/Translate";
import { useTranslation } from "react-i18next";
import { languageStorageKey } from "../i18n";

const LANGS = [
  { code: "es", label: "Español" },
  { code: "en", label: "English" },
  { code: "pt", label: "Português" },
  { code: "fr", label: "Français" },
  { code: "de", label: "Deutsch" },
  { code: "zh", label: "中文" },
];

export default function LanguageSelectIcon() {
  const { i18n, t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const current = (i18n.language || "en").split("-")[0];

  const changeLang = async (lang) => {
    await i18n.changeLanguage(lang);
    localStorage.setItem(languageStorageKey(), lang);
    localStorage.setItem("lang", lang);
    fetch("/api/saas/me/preferences", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      },
      body: JSON.stringify({ language: lang }),
    }).catch(() => {});
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title={t("common.language")}>
        <IconButton aria-label={t("common.language")} aria-haspopup="menu" aria-expanded={open} onClick={(event) => setAnchorEl(event.currentTarget)} size="small" sx={{ width: 36, height: 36 }}>
          <TranslateIcon />
        </IconButton>
      </Tooltip>

      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        {LANGS.map((lang) => (
          <MenuItem key={lang.code} selected={current === lang.code} onClick={() => changeLang(lang.code)}>
            <ListItemIcon sx={{ minWidth: 28 }}>{current === lang.code ? "✓" : ""}</ListItemIcon>
            <ListItemText primary={lang.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
